import { principles } from "@/mocks/site";

export default function PrinciplesSection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-foreground-950" aria-labelledby="principles-title">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <p className="inline-flex items-center gap-2 text-xs font-label tracking-widest text-accent-400 uppercase">
            <span className="w-5 h-px bg-accent-500"></span>
            内容原则
          </p>
          <h2 id="principles-title" className="mt-3 font-heading text-2xl md:text-[32px] font-bold text-background-50 leading-snug">
            我们怎么对待你的每一条材料
          </h2>
          <p className="mt-3 text-sm md:text-base text-background-300 leading-relaxed">
            爆料最怕的不是没人看，而是被轻率对待。我们把流程写死，就是为了让每一次投稿都有迹可循。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-8">
          {principles.map((item) => (
            <div key={item.title} className="flex items-start gap-4">
              <span className="w-11 h-11 rounded-md bg-background-50/10 border border-background-50/15 text-accent-400 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading text-base md:text-lg font-bold text-background-50">{item.title}</h3>
                <p className="mt-1.5 text-sm text-background-300 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}